import React, { Component } from 'react';

import { Slide } from 'react-slideshow-image';

import img1 from '../assets/smokerArticle.jpg';
import img2 from '../assets/bong.JPG';
import img3 from '../assets/clipper.JPG';

import '../App.css';


const slideArticleImages = [
  img1,
  img2,
  img3
]

const propertiesArticle = {
  duration: 4000,
  transitionDuration: 400,
  infinite: true,
  indicators: true,
  arrows: false,
}
class SmokerArticle extends Component {
  render() {
    return (
      <div className="App">
      <div className ="prod-title">
        <h1>Articoli vari per fumatori</h1>
        <br />
      </div>

      <Slide {...propertiesArticle}>
          <div className="article-slide">
            <img src={slideArticleImages[0]} alt="Articoli per fumatori" title="Articoli per fumatori" />
          </div>
          <div className="article-slide">
            <img src={slideArticleImages[1]} alt="Articoli per fumatori" title="Articoli per fumatori" />
          </div>
          <div className="article-slide">
            <img src={slideArticleImages[2]} alt="Articoli per fumatori" title="Articoli per fumatori" />
          </div>
      </Slide>

      <div className="prod-grow">
      <ul>
        <li><h4>CARTINE</h4></li>
        <li><h4>FILTRI</h4></li>
        <li><h4>CLIPPER</h4></li>
        <li><h4>BONG E RICAMBI</h4></li>
        </ul><ul>
        <li><h4>GRINDER</h4></li>
        <li><h4>CHILLUM</h4></li>
        <li><h4>PIPE IN VETRO</h4></li>
        <li><h4>ATTREZZATURA BHO</h4></li>
      </ul>
      </div>
      </div>
    )
  }
}


export default SmokerArticle;
